const zIndex = {
  ScenarioPointer: 21,
  Popper: 21,
  BookOrderDrawer: 22,
  FullModal: 21,
  PageContentsBorder: 11,
  PopperNavigation: 9999,
  Portal: 10000,
  Overlay: 10,
  DropdownList: 9,
  ModalPortal: 20000,
  ConfirmModalPortal: 20100,
  RCTooltip: 20200,
  Tooltip: 20300,
  FadeToast: 30000,
  WaitOverlay: 31000,
  FileDropOverlay: 30100,
}

export default zIndex
